const exportModel = {
  en: {
    exports: {
      title: "Export {resource}",
      resources: {
        source: "Sources",
        article: "Articles"
      },
      youtube_restriction: "Please note that to comply with YouTube regulations, YouTube videos will not be included in the export.",
      include_fulltext: "Include full text"
    }
  }
}

module.exports.export = exportModel;
